import { FC } from 'react'
import cx from 'classnames'

import { RichTextProps } from '../RichText'
import { PictureProps } from '../Picture'
import { LinkProps } from '../Link'

import * as SC from './styled'

export type SearchResultProps = MinimalSeoBlock & {
  className?: string
  title: string
  richtextProps?: RichTextProps
  pictureProps?: PictureProps
  linkProps: LinkProps
}

const SearchResult: FC<SearchResultProps> = ({
  className,
  title,
  richtextProps,
  pictureProps,
  linkProps,
  htmlTag,
  htmlTitleTag,
}) => {
  return (
    <SC.Container className={cx('SearchResult', className)} as={htmlTag}>
      <SC._Link {...linkProps}>
        {pictureProps && <SC._Picture {...pictureProps} />}
        <SC.Content>
          <SC.Title as={htmlTitleTag}>{title}</SC.Title>
          {richtextProps && <SC._RichText {...richtextProps} />}
        </SC.Content>
      </SC._Link>
    </SC.Container>
  )
}

export default SearchResult
